import { CopyProperties } from 'src/app/shared/decorator/copy-properties.decorator';

@CopyProperties()
export class ProductInfo {
    id: number;
    dayCompleteTransaction: number;
    managementFee: number;
    expectedProfit: number;
    firstReleaseAt: any;
    firstReleasePrice: any;
    fundType: string;
    minimumAverageAnnualReturn: number;
    supervisionBank: string;
    investmentStrategyCode: string;
    reportPeriodicalCode: string;
    investingAccount: any;
    gain12m: number;
    gain36m: number;
    risk12m: number;
    avgProfit: number;
    performanceFee: number;

    constructor(
        params?: any
    ) {
        this.id = null;
        this.dayCompleteTransaction = 0;
        this.managementFee = 0;
        this.expectedProfit = 0;
        this.firstReleaseAt = null;
        this.firstReleasePrice = null;
        this.fundType = null;
        this.minimumAverageAnnualReturn = 0;
        this.supervisionBank = null;
        this.investmentStrategyCode = null;
        this.reportPeriodicalCode = null;
        this.investingAccount = null;
        this.gain12m = 0;
        this.gain36m = 0;
        this.risk12m = 0;
        this.avgProfit = 0;
        this.performanceFee =  0;
    }
}
